'use strict';

const Rx = require('../../rlink-rx');
const { xhr } = require('../../rlink-utils/xhr');

const areRelatedEmbeddedValues = require('../areRelatedEmbeddedValues');
const embedded = require('../embedded');
const lookupMeta = require('../lookupMeta');
const setRequestPending = require('../setRequestPending');
const setRequestTimeoutId = require('../setRequestTimeoutId');

function isCancelled (caches, request, requestArgs) {
  const meta = lookupMeta(caches, request, ...requestArgs);
  return meta.cancelled;
}

function splitRelatedEmbeddedValues (embeddedValues) {
  if (areRelatedEmbeddedValues(embeddedValues)) {
    return embeddedValues;
  }

  return [[], embeddedValues];
}

module.exports = function httpRequestStream ({
  method,
  url,
  mapResponse,
  headers,
  interval = -1,
}) {
  return ({ getCaches, request, requestArgs }) => (
    Rx.Observable.create(observer => {
      const dorequest = async () => {
        observer.onNext([setRequestPending(request, requestArgs)]);

        try {
          const responseEnvelope = await xhr(method, url, null, headers);
          const [relatedValues, value] =
                splitRelatedEmbeddedValues(mapResponse(responseEnvelope.response));

          observer.onNext([
            ...relatedValues,
            embedded(request, requestArgs, value),
          ]);

          if (interval > -1
              && !isCancelled(getCaches(), request, requestArgs)) {
            const timeoutId = setTimeout(dorequest, interval);

            observer.onNext([
              setRequestTimeoutId(request, requestArgs, timeoutId),
            ]);
          } else {
            observer.onCompleted();
          }
        } catch (err) {
          observer.onError(err);
        }
      };

      dorequest();
    })
  );
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/streams/httpRequestStream.js